import React, { FC, useState } from 'react'
import { Alert, Button, Card, Col, Form, Modal, Row } from 'react-bootstrap'
import DataTable from 'react-data-table-component'
import { IconContext } from 'react-icons'
import { useDispatch, useSelector } from 'react-redux'
import ICatTipoUnidades from '../../Interfaces/Catalogos/ICatTipoUnidades'
import { RootState } from '../../store/store'
import { BsFillPencilFill, BsFillTrashFill, BsSave } from 'react-icons/bs'
import DSCatTipoUnidades from '../../Services/Catalogos/CatTipoUnidades.Services'
import { updateCatTipoUnidades, deleteCatTipoUnidades } from '../../store/features/Catalogos/CatTipoUnidadesSlice'

interface IProps {}

export const CatTipoUnidades: FC<IProps> = (props) => {
  const dispatch = useDispatch()
  const CatTipoUnidades = useSelector((state: RootState) => state.CatTipoUnidades.CatTipoUnidades)
  const [showCatTipoUnidadesDialog, setShowCatTipoUnidadesDialog] = useState(false)
  const [deleteCatTipoUnidadesDialog, setDeleteCatTipoUnidadesDialog] = useState(false)
  const [IDTipoUnidad, setIDTipoUnidad] = useState(0)
  const [TipoUnidad, setTipoUnidad] = useState('')
  const [Search, setSearch] = useState('')
  const columnsConcepts = [
    {
      name: 'id',
      width: '80px',
      selector: (row: ICatTipoUnidades) => row.id,
      sortable: true,
    },
    {
      name: 'Tipo unidad',
      width: '450px',
      selector: (row: ICatTipoUnidades) => row.tipoUnidad,
      sortable: true,
    },
    {
      name: 'Editar',
      width: '100px',
      cell: (row: ICatTipoUnidades) => (
        <div
          style={{ textAlign: 'center', cursor: 'pointer' }}
          onClick={() => {
            showInfo(row)
          }}
        >
          <IconContext.Provider value={{ color: 'blue', size: '21px' }}>
            <BsFillPencilFill />
          </IconContext.Provider>
        </div>
      ),
      sortable: true,
    },
    {
      name: 'Elimina',
      width: '100px',
      cell: (row: ICatTipoUnidades) => (
        <div
          style={{ textAlign: 'center', cursor: 'pointer' }}
          onClick={() => {
            confirmDelete(row)
          }}
        >
          <IconContext.Provider value={{ color: 'red', size: '21px' }}>
            <BsFillTrashFill />
          </IconContext.Provider>
        </div>
      ),
      sortable: true,
    },
  ]

  const showInfo = (data: ICatTipoUnidades) => {
    setIDTipoUnidad(data.id)
    setTipoUnidad(data.tipoUnidad)
    setShowCatTipoUnidadesDialog(true)
  }

  const confirmDelete = (data: ICatTipoUnidades) => {
    setIDTipoUnidad(data.id)
    setTipoUnidad(data.tipoUnidad)
    setDeleteCatTipoUnidadesDialog(true)
  }

  const deleteInfo = () => {
    DSCatTipoUnidades.Delete(IDTipoUnidad)
      .then((response) => {
        dispatch(deleteCatTipoUnidades(IDTipoUnidad))
      })
      .catch((e: Error) => {})
    setDeleteCatTipoUnidadesDialog(false)
  }

  const saveInfo = () => {
    const data: ICatTipoUnidades = {
      id: IDTipoUnidad,
      tipoUnidad: TipoUnidad,
      activo: 1,
    }
    DSCatTipoUnidades.Append(data)
      .then((response) => {
        dispatch(updateCatTipoUnidades(response.data))
      })
      .catch((e: Error) => {})
    setShowCatTipoUnidadesDialog(false)
  }

  const filtraReporte = (e: any) => {
    setSearch(e.target.value)
  }

  return (
    <div>
      <Row>
        <Col xs={12}>
          <Card style={{}}>
            <Card.Body>
              <Card.Title style={{ textAlign: 'left' }}>
                <Alert variant='primary'>Tipo Unidades</Alert>
              </Card.Title>
              <Row>
                <Col xs={12}>
                  <Form.Control
                    type='text'
                    size='sm'
                    placeholder='Search...'
                    onChange={(e) => {
                      filtraReporte(e)
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                  <DataTable
                    noHeader
                    defaultSortFieldId={'id'}
                    defaultSortAsc={true}
                    striped={true}
                    dense={true}
                    paginationPerPage={10}
                    pagination
                    highlightOnHover
                    columns={columnsConcepts}
                    data={CatTipoUnidades.filter(function (row: ICatTipoUnidades) {
                      return row.tipoUnidad.includes(Search)
                    })}
                    pointerOnHover
                  />
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Modal
        show={showCatTipoUnidadesDialog}
        onHide={() => {
          setShowCatTipoUnidadesDialog(false)
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Catalogo: Tipo unidades</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col xs={4}>No tipo unidad</Col>
            <Col xs={2}>
              <Form.Control type='text' id='IDCliente' value={IDTipoUnidad} disabled size='sm' />
            </Col>
          </Row>
          <br />
          <Row>
            <Col xs={3}>Tipo unidad</Col>
            <Col xs={9}>
              <Form.Control
                type='text'
                id='TipoUnidad'
                value={TipoUnidad}
                size='sm'
                onChange={(e) => {
                  setTipoUnidad(e.target.value)
                }}
              />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Row>
            <Col xs={2}></Col>
            <Col xs={3}>&nbsp;</Col>
            <Col xs={3}>
              <Button
                variant='primary'
                onClick={() => {
                  saveInfo()
                }}
              >
                Guarda
              </Button>
            </Col>
          </Row>
        </Modal.Footer>
      </Modal>
      <Modal
        show={deleteCatTipoUnidadesDialog}
        onHide={() => {
          setDeleteCatTipoUnidadesDialog(false)
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Catalogo: Clientes</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <br />
          <Row>
            <Col xs={12}>
              <Alert variant='warning'>
                ¿Esta seguro de que desea eliminar el cliente: <br />
                <span style={{ fontWeight: 'bold', fontSize: '20px' }}>{TipoUnidad}</span>?
              </Alert>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Row>
            <Col xs={2}></Col>
            <Col xs={3}>&nbsp;</Col>
            <Col xs={3}>
              <Button
                variant='danger'
                onClick={() => {
                  deleteInfo()
                }}
              >
                Elimina
              </Button>
            </Col>
          </Row>
        </Modal.Footer>
      </Modal>
    </div>
  )
}
